/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Response from creating an S3 Access Point for Redshift access. 
*/
export class CreateRedshiftAccessPointResponse {
  /**
  * ARN of the created S3 Access Point.
  */
  'accessPointArn': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accessPointArn",
      "baseName": "accessPointArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateRedshiftAccessPointResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

